import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdLocationOn } from "react-icons/md";
import illusMobility from "../../../assets/images/illusMobility.jpg";
import ModalDetailMobility from "./ModalDetailMobility";

const ComponentMobility = (props) => {
  const { t } = useTranslation();
  const { mobility } = props;
  const [showDetails, setShowDetails] = useState(false);

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  return (
    <div className="d-flex flex-column" id={"mobility_" + mobility._id}>
      <span className="componentMobilityLocalisation ms-2 d-flex align-items-center">
        <MdLocationOn size="1.5em" color="#BBBBBB" />
        {mobility.localisation.nom}
      </span>
      <Card
        className="componentMobility ms-2 me-2 mb-2 flex-grow-1"
        onClick={() => {
          handleShowDetails();
        }}
        role="button"
      >
        <Card.Img
          variant="top"
          src={
            mobility.cardPic
              ? process.env.REACT_APP_URL_EXPRESS + "images/mobility/small/" + mobility.cardPic
              : illusMobility
          }
          style={{ height: 85 }}
        />
        <Card.Body className="d-flex flex-column">
          <div className="flex-grow-1">
            <Card.Title>{mobility.nom}</Card.Title>
          </div>
        </Card.Body>
      </Card>
      <ModalDetailMobility
        mobility={mobility}
        show={showDetails}
        handleClose={handleCloseDetails}
      />
    </div>
  );
};

export default ComponentMobility;
